import { gsap } from 'gsap';

const animationDuration = 0.5;

export function fadeIn(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // force opacity to 0
        targetEl.style.opacity = 0
        // tween to opacity 1
        gsap.to(targetEl, {
            display: 'block',
            opacity: 1,
            duration: animationDuration,
            onComplete: resolve
        })
    })
}

export function fadeOut(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // tween to opacity 0
        gsap.to(targetEl, {
            opacity: 0,
            duration: animationDuration,
            onComplete: () => {
                targetEl.style.display = "none";
                resolve();
            }
        })
    });
}